var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_1088)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2007_1088",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4601 0.915573H0.27832V18.0973H17.4601V0.915573Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2007_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00424 1.44208C8.36722 0.740072 9.37115 0.740072 9.73412 1.44208L12.0455 5.9124C12.1381 6.09154 12.2841 6.2375 12.4633 6.33012L16.9335 8.6415C17.6356 9.00447 17.6356 10.0084 16.9335 10.3714L12.4633 12.6827C12.2841 12.7754 12.1381 12.9213 12.0455 13.1005L9.73412 17.5708C9.37115 18.2728 8.36722 18.2728 8.00424 17.5708L5.69287 13.1005C5.60024 12.9213 5.45429 12.7754 5.27515 12.6827L0.804823 10.3714C0.102819 10.0084 0.102819 9.00447 0.804823 8.6415L5.27515 6.33012C5.45429 6.2375 5.60024 6.09154 5.69287 5.9124L8.00424 1.44208Z",
    fill: "#7551DC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_1088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1817,
    height: 17.1817,
    fill: "white",
    transform: "translate(0.27832 0.915573)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.28302d76ca0625d3442c7e9135491b69.svg";
export { ForwardRef as ReactComponent };